import { render, staticRenderFns } from "./manageUserEbook.vue?vue&type=template&id=ab0c733e&"
import script from "./manageUserEbook.vue?vue&type=script&lang=js&"
export * from "./manageUserEbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports